import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { Ripple } from "vuetify/lib/directives";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify,
  {
    directives: {
      Ripple,
    }
  }
);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // Custom colors go here
        // Play at https://theme-generator.vuetifyjs.com/
        primary: "#000000",

        // Defaults:
        // primary: "#1976D2",
        secondary: "#666666",
        accent: "#c31924",
        error: "#c31924",
        info: "#666666",
        success: "#BCD0D2",
        warning: "#c31924",

        anchor: "#c31924",
      },
    },
  },
});
